import { useTranslation } from 'common/core/coreHooks'

export const TranslationService = () => {
  useTranslation()
  return null
}
